import mixin from './mixin'

const Automan = {
  mixin
}

export {
  mixin
}

export default Automan
